import KemImage from "@ch/assets/images/kem.svg";
import { AppRoutesEnum } from "@ch/router/AppRoutes/enums";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

const KemUnavailableScreen: FC = () => {
  const navigate = useNavigate();

  const handleRefresh = () => {
    void navigate(AppRoutesEnum.KEM);
  };

  return (
    <div className="flex w-full max-w-md flex-col items-center gap-12 px-4 py-12">
      <div className="w-full rounded-2xl border border-gray-300 px-4 py-12 text-center">
        <div className="mb-8 flex justify-center">
          <div className="flex h-[84px] w-[84px] items-center justify-center rounded-full bg-green-100">
            <img alt="Kem" className="h-12 w-12" src={KemImage} />
          </div>
        </div>
        <p className="text-base text-ink-900">
          We&apos;re sorry, but Kem is currently unavailable. Please check back
          soon for updates. If you have any questions, please{" "}
          <a
            className="text-green hover:underline"
            href="https://mymdoc.com/contact-us"
            rel="noopener noreferrer"
            target="_blank"
          >
            contact us
          </a>
          . If you think this is an error, please try refreshing the page or
          click the button below.
        </p>
      </div>
      <button
        className="w-full rounded-xl bg-[#FD6E5E] px-4 py-3 text-white transition-opacity hover:opacity-90"
        onClick={handleRefresh}
        type="button"
      >
        Refresh Page
      </button>
    </div>
  );
};

export default KemUnavailableScreen;
